import React from "react";
import { Container, Row, Col } from "reactstrap";
import TableRow from "./TableRow";
import { joinCss } from "../helpers/utils";

import appClasses from "../App.module.scss";
import classes from "./TableList.module.scss";

function tableList(props) {
  var toReturn = (
    <Container className={joinCss(appClasses["margin-x-axis-4"], "mb-5")}>
      <Row className={classes.titles}>
        {props.tableSettings.columns.map((columnData, index) => (
          <Col key={index} scope="col" sm={columnData.size}>
            {columnData.displayString}
          </Col>
        ))}
      </Row>
      {props.list.map(element => (
        <TableRow
          key={element.docIdentity}
          data={element}
          tableSettings={props.tableSettings}
        />
      ))}
    </Container>
  );

  return toReturn;
}

export default tableList;
